import stringReplacer from './string';
export default function (_, mods, value) {
    return stringReplacer('s', mods, (typeof value === 'object'
        ? (Array.isArray(value)
            ? 'array'
            : 'object')
        : typeof value));
}
